exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deviceStatus_cla .zaixian[data-v-69aa860a]{color:#78bc27;font-size:1.416667rem}.deviceStatus_cla .lixian[data-v-69aa860a]{color:#ea1422;font-size:1.083333rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69aa860a","scoped":true,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":12}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/comComponent/deviceStatus.vue
// module id = QuIT
// module chunks = 19